import { Component, Input } from '@angular/core';
import { StoreTemplateStatus, UiWidget } from '@pt/pt-models';
import { WidgetType } from 'it/primatoo/openapi/api/org/schemas/common/docs/WidgetType';
import { DeveloperModeService } from '@pt/api-client';

@Component({
  selector: 'pt-template-editor-list-widget',
  template: `
    <pt-dev-widget-info [widget]="widget" *ngIf="devMode.debugModeEnabled()">
    </pt-dev-widget-info>
    <div [ngSwitch]="widget?.type" class="global-widget-container">
      <pt-widget-date
        *ngSwitchCase="WidgetType.DATE"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-date>

      <pt-widget-dpia
        *ngSwitchCase="WidgetType.DPIA"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-dpia>

      <pt-widget-app-summary
        *ngSwitchCase="WidgetType.APP_SUMMARY"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-app-summary>

      <pt-widget-attachment
        *ngSwitchCase="WidgetType.ATTACHMENT"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-attachment>

      <pt-widget-risk-assessment
        *ngSwitchCase="WidgetType.RISK_ASSESSMENT"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-risk-assessment>

      <pt-widget-multi-question
        *ngSwitchCase="WidgetType.MULTI_QUESTION"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-multi-question>

      <pt-widget-html
        *ngSwitchCase="WidgetType.HTML"
        [lockAcquired]="false"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-html>

      <pt-widget-preliminary-risk-assessment
        *ngSwitchCase="WidgetType.PRELIMINARY_RISK_ASSESSMENT"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-preliminary-risk-assessment>

      <pt-widget-simple-radiobutton
        *ngSwitchCase="WidgetType.SIMPLE_RADIO_BUTTON"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-simple-radiobutton>

      <pt-widget-recipient-chooser
        *ngSwitchCase="WidgetType.RECIPIENT_CHOOSER"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-recipient-chooser>

      <pt-widget-checkbox
        *ngSwitchCase="WidgetType.CHECKBOX"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-checkbox>

      <pt-widget-text
        *ngSwitchCase="WidgetType.TEXT"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-text>

      <pt-widget-contact-chooser
        *ngSwitchCase="WidgetType.CONTACT_CHOOSER"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-contact-chooser>

      <pt-widget-treatment-data-interested
        *ngSwitchCase="WidgetType.TREATMENT_DATA_INTERESTED"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-treatment-data-interested>

      <pt-widget-data-retention-and-deletion
        *ngSwitchCase="WidgetType.DATA_RETENTION_AND_DELETION"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-data-retention-and-deletion>

      <pt-widget-radiobutton
        *ngSwitchCase="WidgetType.RADIO_BUTTON"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-radiobutton>

      <pt-widget-app-assessment
        *ngSwitchCase="WidgetType.APP_ASSESSMENT"
        [lockAcquired]="lockAcquired"
        [status]="status"
        [initializationWidget]="widget"
      >
      </pt-widget-app-assessment>

      <ng-container *ngSwitchDefault>
        <pt-widget-not-supported
          [initializationWidget]="widget"
        ></pt-widget-not-supported>
      </ng-container>
    </div>
  `,
})
export class TemplateEditorWidgetGroupComponent {
  @Input() status: StoreTemplateStatus;
  @Input() lockAcquired: boolean;

  @Input() widget: UiWidget;

  WidgetType = WidgetType;

  constructor(public devMode: DeveloperModeService) {}
}
